module.exports = {
  common: {
    ok: '確定',
    cancel: '取消'
  },
  language: {
    name: '中文'
  },
  header: {
    lang: 'English',
    home: '首頁',
    allproduct: '全部產品種類',
    product: '產品世界',
    productccc: '3C認證產品',
    video: '視頻中心',
    star: '海陽之星',
    news: '新聞動態',
    plan: '展覽計劃',
    about: '關於海陽',
    contact: '聯系我們',
    Exchange: '外匯牌價',
    search: '請輸入產品關鍵字',
    langageimg: 'en.png',
    computry: '海陽玩具貿易有限公司',
    welcome: '歡迎您!',
    login: '請登錄',
    register: '註冊',
    registernew: '註冊為新用戶',
    notuser: '沒有賬號',
    highsearch: '高級搜索',
    buyshop: '購物車',
    account: '賬號',
    password: '密碼',
    name: '姓名',
    phone: '電話',
    keyword: '請輸入關鍵詞'
  },
  home: {
    hot: '熱選排行',
    halfmonth: '半個月',
    onemonth: '一個月',
    threemonths: '三個月',
    halfyear: '半年',
    newproduct: '每日新品',
    videoproduct: '產品視頻',
    productSearch: '產品搜索',
    productName: '樣品名稱：',
    productItem: ' 樣品編號：',
    productPackage: '包裝方式：',
    productP: '樣品貨號：',
    productbc: '樣品大類：',
    productsc: '樣品小類：',
    productnum: '裝箱數量：',
    productpb: '　價格　：',
    productpe: '　　~　　',
    search: '搜索',
    PIK: '請輸入內容',
    PS: '請選擇'
  },
  contact: {
    name: '姓名',
    phone: '分機號碼',
    email: '郵箱',
  },
  footer: {
    lang: 'English',
    home: '　首　頁　',
    product: '產品展示',
    video: '視頻中心',
    news: '新聞動態',
    about: '關於海陽',
    concact: '地址：香港官塘巧明街105號好運工業大廈7字樓B室　郵箱:seasunhk@163.com',
    power: 'Copyright 海陽玩具貿易有限公司 2022-2030 All Right Reserved ',
    address: ''
  },
  productdetails: {
    gologin: '請登錄',
    cpzl: '產品種類：',
    jrgwc: '加入購物車',
    cpbz: '包裝：',
    wxsl: '外箱裝量：',
    lwh: '長寬高(cm) ：',
    outlwh: '外箱長寬高(cm)：',
    cprq: '日期：',
    nhgs: '內盒個數：',
    tj: '體積(m³)：',
    mj: '毛/凈重(kg)：',
    spms: '商品描述：',
    jcxj: '基礎信息：',
    cphh: '產品貨號：',
    cjbh: '廠家貨號：',
    cpmc: '產品名稱：',
    ccbz: '尺寸&包裝：',
    ccclfs: '尺寸測量方式：',
    tccp: '同廠產品：'
  },
  product: {
    new: '新品',
    hot: '熱度',
    price: '價格',
    video: '視頻',
    total: '共',
    productcount: '款產品'
  },
  cart: {
    exporte: '導出',
    mutidelete: '批量刪除',
    image: '樣品圖片',
    info: '樣品信息',
    number: '編號:',
    name: '名稱:',
    delete: '刪除',
    count: '數量',
    price: '單價',
    subtotal: '小價',
    operation: '操作'
  },
  about: {
    companyintroduction: '企業簡介',
    enterprisehonor: '聯系我們',
    sampleexhibits: '樣品展示',
    newstendency: '新聞動態'
  }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js